import { atom, selector } from "recoil";
import type { CustomImpositionLayoutState } from "./types";
import { getCustomCalculationBlock } from "./custom-imposition.request";

export const customImpositionByProductTypeState = atom<
  Record<string, CustomImpositionLayoutState>
>({
  key: "customImpositionByProductTypeState",
  default: {},
});

export const customImpositionCalculationBlockState = selector({
  key: "customImpositionCalculationBlockState",
  get: ({ get }) => getCustomCalculationBlock(get(customImpositionByProductTypeState)),
});
